<template>
  <div class="mt-10">
    <LoadingSpinner />
  </div>
</template>

<script>
import LoadingSpinner from "./LoadingSpinner.vue"

export default {
  components: {
    LoadingSpinner
  }
}
</script>